import React, { useState, useContext, use, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useUtilisateur from "../../hooks/useUtilisateur";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../assets/css/authentification/signin.css";
import imgGoogle from "../../assets/images/authentification/google.png";
import imgFacbook from "../../assets/images/authentification/facebook.png";
import imgApple from "../../assets/images/authentification/apple.png";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";
const Signin = ({ setAlert }) => {
  const { login, verifyCaptchaV3, isLoading, setIsLoading } =
    useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const erreurFacebookNoEmail =
    searchParams.get("error") === "facebook_no_email";
  const { createUser } = useUtilisateur();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [telephone, setTelephone] = useState("");
  const [ville, setVille] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [typeCompte, setTypeCompte] = useState(1);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (erreurFacebookNoEmail) {
      setAlert({
        message:
          "Votre compte facebook n’a pas d’adresse email associée, veuillez utiliser une autre méthode de connexion ou créer un compte avec votre adresse email.",
        type: "danger",
      });
    }
  }, []);

  const generateDeviceId = () => {
    if (crypto.randomUUID) {
      return crypto.randomUUID();
    } else {
      // fallback simple
      return `${Date.now()}-${Math.random()}`;
    }
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    localStorage.setItem("navigation", "signin");
    setIsLoading(true);

    if (!executeRecaptcha) {
      alert("Recaptcha non encore chargé");
      setIsLoading(false);
      return;
    }

    try {
      // Génération du token reCAPTCHA v3
      const token = await executeRecaptcha("inscription");
      const captchaRes = await verifyCaptchaV3({ token });

      if (!captchaRes?.data?.success) {
        setAlert({
          message: "Captcha invalide!",
          type: "danger",
        });
        setIsLoading(false);
        return;
      }

      // Vérification des mots de passe
      if (password !== confirmPassword) {
        setAlert({
          message: "Les mots de passe ne correspondent pas !",
          type: "danger",
        });
        setIsLoading(false);
        return;
      }

      // Création du FormData
      const formData = new FormData();
      formData.append("nom", nom);
      formData.append("prenom", prenom);
      formData.append("tel", telephone);
      formData.append("ville", ville);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("passwordConfirm", confirmPassword);
      formData.append("isSubscribed", isSubscribed);
      formData.append("typeCompte", typeCompte);
      // Création de l'utilisateur
      await createUser("?source=profile", formData);
      // Connexion automatique après inscription
      await login({ email, password });
    } catch (error) {
      console.log(error?.response?.data?.message);
      setAlert({
        message: error?.response?.data?.message || error.message,
        type: "danger",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleConnectGoogle = async () => {
    setIsLoading(true);
    localStorage.setItem("navigation", "signin");
    if (!executeRecaptcha) {
      setAlert({
        message: "Captcha non chargé !",
        type: "danger",
      });
      setIsLoading(false);
      return;
    }
    try {
      const token = await executeRecaptcha("login");
      const captchaRes = await verifyCaptchaV3({ token });

      if (!captchaRes.data.success) {
        setAlert({
          message: "Une activité suspect a été detectée, veuillez réessayer !",
          type: "danger",
        });
        setIsLoading(false);
        return;
      }
      window.location.href = `${process.env.REACT_APP_ARTICLE_IMAGE}/auth/google`;
    } catch (error) {
      setIsLoading(false);
      setAlert({
        message:
          "Erreur lors de la vérification Captcha ou de la connexion Google.",
        type: "danger",
      });
    }
  };

  const handleConnectFacebook = async () => {
    // setIsLoading(false);
    // setAlert({
    //   message: "La connexion avec Facebook sera disponnible bientôt.",
    //   type: "info",
    // });
    localStorage.setItem("navigation", "login");

    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = generateDeviceId();
      localStorage.setItem("deviceId", deviceId);
    }

    window.location.href = `${process.env.REACT_APP_ARTICLE_IMAGE}/auth/facebook?deviceId=${deviceId}`;
  };

  return (
    <>
      {isLoading ? (
        <>
          <LoaderAuth />
        </>
      ) : (
        <>
          <div className="container pb-5 mb-5 pt-5">
            <i
              class="bi bi-x-circle signin_icon_x"
              role="button"
              onClick={() => navigate("/")}
            ></i>
            <div className="signin_navigation">
              <div role="button" className="signin_active">
                je créer mon compte
              </div>
              <div role="button" onClick={() => navigate("/connexion")}>
                j'ai déja un compte
              </div>
            </div>
            <div className="signin_welcome">
              <h1>Bonjour</h1>
              <p>Inscrivez vous ou connecter vous avec votre compte</p>
            </div>
            <div className="signin_social_buttons">
              <button onClick={handleConnectGoogle}>
                {" "}
                <img src={imgGoogle} alt="google" />
                Continuer avec Google
              </button>
              {/* <button>
                {" "}
                <img src={imgApple} alt="apple" />
                Continuer avec Apple
              </button> */}
              <button onClick={handleConnectFacebook}>
                {" "}
                <img src={imgFacbook} alt="facebook" />
                Continuer avec Facebook
              </button>
            </div>
            <hr className="signin_hr" />
            <form className="signin_form" onSubmit={handleSubmit}>
              <div className="signin_radio_group mb-3">
                <div className="d-flex justify-content-start align-items-center">
                  <input
                    type="radio"
                    name="typeCompte"
                    value={1}
                    checked={typeCompte == 1}
                    onChange={() => setTypeCompte(1)}
                  />
                  <span style={{ fontWeight: "bold" }}>Particulier</span>
                </div>
                <div className="d-flex justify-content-start align-items-center">
                  <input
                    type="radio"
                    name="typeCompte"
                    value={2}
                    checked={typeCompte == 2}
                    onChange={() => setTypeCompte(2)}
                  />
                  <span style={{ fontWeight: "bold" }}>Professionel</span>
                </div>
              </div>
              <input
                type="text"
                placeholder="Nom"
                className="signin_input_text"
                defaultValue={nom}
                onChange={(e) => setNom(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Prénom"
                className="signin_input_text"
                defaultValue={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Téléphone"
                className="signin_input_text"
                defaultValue={telephone}
                onChange={(e) => setTelephone(e.target.value)}
                required
              />
              <input
                type="mail"
                placeholder="Email"
                className="signin_input_text"
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="ville"
                className="signin_input_text"
                defaultValue={ville}
                onChange={(e) => setVille(e.target.value)}
                required
              />
              <div className="w-100 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Votre mot de passe"
                  className="signin_input_text w-100 "
                  defaultValue={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i
                  class="bi bi-eye position-absolute"
                  style={{ top: "15px", right: "25px", fontSize: "18px" }}
                  role="button"
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
              <p>
                Pour plus de sécurité, votre mot de passe doit contenir au moins
                une Majuscule, une minuscule et une chiffre Minimum length of 6
                characters.
              </p>
              <div className="w-100 position-relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirmer votre mot de passe"
                  className="signin_input_text w-100 "
                  defaultValue={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <i
                  class="bi bi-eye position-absolute"
                  style={{ top: "15px", right: "25px", fontSize: "18px" }}
                  role="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                ></i>
              </div>
              <p>Tout les champs sont obligatoires</p>
              <div className="d-flex justify-content-start align-items-center">
                <input
                  type="radio"
                  checked={isSubscribed}
                  onChange={() => setIsSubscribed(!isSubscribed)}
                />
                <span>
                  {" "}
                  je souhaite recevoir par e-mail les remises et astuces
                </span>
              </div>
              <div className="d-flex justify-content-start align-items-center">
                <input
                  type="radio"
                  checked={termsAccepted}
                  onChange={() => setTermsAccepted(!termsAccepted)}
                />
                <span>
                  {" "}
                  j'accepte les conditions générales et la politique de
                  confidentialité
                </span>
              </div>
              <button
                type="submit"
                className="sigin_validate"
                disabled={termsAccepted ? false : true || isLoading}
              >
                CREER MON COMPTE
              </button>
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default Signin;
